import { FunctionComponent, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';
import classes from './MyTopicsFilter.module.scss';

enum FollowedFilter {
  ALL = 'all',
  FOLLOWED = 'followed',
  UNFOLLOWED = 'unfollowed',
}

interface FollowedFilterOption {
  id: FollowedFilter;
  label: string;
  feedFollowedStatus?: boolean;
}

interface MyTopicsFilterProps {
  feedFollowedStatus?: boolean;
  onChange: (feedFollowedStatus?: boolean) => void;
}

export const MyTopicsFilter: FunctionComponent<MyTopicsFilterProps> = memo(
  ({ feedFollowedStatus, onChange }) => {
    const { t } = useTranslation();

    const { t: ctxT } = useTranslation('', { keyPrefix: 'myTopics' });

    const options = useMemo<FollowedFilterOption[]>(
      () => [
        { id: FollowedFilter.ALL, label: t('common.all') },
        { id: FollowedFilter.FOLLOWED, label: ctxT('followed'), feedFollowedStatus: true },
        { id: FollowedFilter.UNFOLLOWED, label: ctxT('unfollowed'), feedFollowedStatus: false },
      ],
      [ctxT, t]
    );

    return (
      <div className={classes['my-topics-filter']} role={'group'}>
        {options.map(({ id, label, feedFollowedStatus: optionFollowedStatus }) => {
          const isActive = optionFollowedStatus === feedFollowedStatus;

          return (
            <button
              key={id}
              type={'button'}
              className={classNames(classes['my-topics-filter__pill'], {
                [classes['my-topics-filter__pill--active']]: isActive,
              })}
              aria-pressed={isActive}
              onClick={() => onChange(optionFollowedStatus)}
            >
              {label}
            </button>
          );
        })}
      </div>
    );
  }
);
